import { ITranslations } from '@/i18n/ITranslations';

export const de: ITranslations = {
  'admin.emptySection':
    'Dieser Bereich "<strong>((sectionName))</strong>" scheint leer zu sein - es dürfte sich um einen Fehler handeln. Bitte kontaktieren Sie Ihren System-Adminstrator.',
  'general.appStartPage': 'App Startseite',
  userName: 'Benutzername',
  userRole: 'Benutzerrolle',
  momentInTime: 'Zeitpunkt',
  archive: `Archiv`,
  account: `Benutzerkonto`,
  options: `Optionen`,
  'archive.type.monthly': 'Monatlich',
  'archive.type.weekly': 'Wöchentlich',
  'billingType.EUROPE': 'Europa',
  'billingType.OTHER': 'Sonstige',
  'billingType.UK': 'UK',
  'contacts.createNewCompany': `((icon)) Neue Firma '((searchValue))' erstellen...`,
  'contacts.createNewPerson': `((icon)) Neue Person '((searchValue))' erstellen...`,
  'contacts.editOrCopy': 'Kontakt bearbeiten / duplizieren',
  'contacts.new': 'Neuen Kontakt erstellen',
  'contacts.new.success': 'Neuer Kontakt erfolgreich erstellt.',
  'contacts.new.error': 'Erstellung des neuen Kontakts fehlgeschlagen.',
  'contacts.edit.success': 'Kontakt erfolgreich bearbeitet.',
  'contacts.edit.error': 'Bearbeitung des Kontakts fehlgeschlagen.',
  'contacts.copy.success': 'Kontakt erfolgreich kopiert.',
  'contacts.copy.error': 'Kopieren des Kontakts fehlgeschlagen.',
  'contacts.noFurtherContactsAvailable': 'Keine weiteren Kunden verfügbar',
  'customer.address': 'Adresse',
  'customer.addressAddition': 'Adresszusatz',
  'customer.city': 'Stadt',
  'customer.company': 'Firma',
  'customer.country': 'Land',
  'customer.email': 'Email',
  'customer.firstName': 'Vorname',
  'customer.houseNr': 'Haus-Nr.',
  'customer.lastName': 'Nachname',
  'customer.phoneNumber': 'Telefonnummer',
  'customer.street': 'Straße',
  'customer.zipCode': 'PLZ',
  'general.apply': 'Übernehmen',
  'general.area.EUROPE': 'Europa',
  'general.area.OTHER': 'Andere',
  'general.area.UK': 'UK',
  'general.create': 'Erstellen',
  'general.duplicate': 'Duplizieren',
  'general.disable': 'Deaktivieren',
  'general.edit': 'Bearbeiten',
  'general.copy': 'Kopieren',
  'general.copyPrefix': 'KOPIE-VON-',
  'general.new': 'Neu',
  'general.no': 'Nein',
  'general.open': 'Öffnen',
  'general.logoutConfirm': 'Möchten Sie sich wirklich ausloggen?',
  'general.positions': 'Positionen',
  'general.redirect': 'Umleiten',
  'general.saveChanges': 'Änderungen speichern',
  'general.saveNewContact': 'Neuen Kontakt speichern',
  'general.saveNewCopy': 'Neue Kopie speichern',
  'general.showMore': 'Mehr anzeigen',
  'general.yes': 'Ja',
  'general.optional': 'Optional',
  'general.forAll': 'Für irgendjemanden',
  'internalOrder.position': 'Position',
  'internalOrder.total': 'Betrag',
  'internalOrder.creation.success': 'Interne Bestellung erfolgreich erstellt',
  'internalOrder.creation.error': 'Erstellung von interner Bestellung fehlgeschlagen',
  'language.de': 'Deutsch',
  'language.en': 'Englisch',
  'loading.checkingSession': 'Session wird überprüft...',
  'loading.fetchDataError': 'Ein Fehler ist beim Abrufen der Basis Daten aufgetreten',
  'loading.fetchSettingsError': 'Ein Fehler ist beim Abrufen der Basis Settings aufgetreten',
  'loading.pleaseWait': 'Bitte warten...',
  'loading.redirecting': 'Leite weiter...',
  'loading.retrievingData': 'Abrufen von Basis Daten...',
  'loading.retrievingSettings': 'Abrufen von Basis Settings...',
  'loading.tryAgain': 'Nochmal versuchen',
  'order.declined.reason': 'Begründung',
  'order.showAllInStatus': "Zeige alle Bestellungen mit Status '((status))'",
  'order.noFurtherOrdersAvailable': 'Keine weiteren Bestellungen verfügbar',
  'order.track': 'Verfolgen',
  'order.redirect': 'Bestellung ((order)) umleiten',
  'order.redirect.success': 'Bestellung erfolgreich umgeleitet',
  'order.redirect.error': 'Umleiten der Bestellung fehlgeschlagen',
  'order.search': 'Suche',
  'order.searchPlaceholder': 'Freie Suche...',
  'order.trackingNumber': 'Sendungsverfolgungsnummer',
  'order.trackingLinkText': 'Sendung auf externer Webseite verfolgen',
  'order.positions': 'Positionen',
  'order.cancel': 'Bestellung stornieren',
  'order.cancel.confirm': `Bestellung ((orderId)) wirklich stornieren?`,
  'order.cancel.success': 'Bestellung erfolgreich storniert',
  'order.cancel.error': 'Stornierung der Bestellung fehlgeschlagen',
  'order.positions.multipleGroupsError':
    'Positionen aus mehreren Produktgruppen (((productGroups))) sind nicht zulässig',
  'order.positions.titles': 'Bezeichnungen',
  'order.positions.type': 'Einsatzbereich',
  'order.positions.forOrders': 'Für Bestellungen',
  'order.positions.forPreorders': 'Für Vorbestellungen',
  'order.positions.forBoth': 'Für beide',
  'order.positions.amount.aboveExpressTotalMax':
    'Maximale Gesamtmenge für EXPRESS Vorbestellungen ist ((expressLimitTotal))',
  'order.positions.noTypeChangeAllowed.ORDER':
    'Der Einsatzbereich für eine bestehende Position kann nicht geändert werden. Erstellen Sie stattdessen eine neue Position für Bestellungen.',
  'order.positions.noTypeChangeAllowed.PREORDER':
    'Der Einsatzbereich für eine bestehende Position kann nicht geändert werden. Erstellen Sie stattdessen eine neue Position für Vorbestellungen.',
  'order.positions.id': 'ID',
  'order.positions.userRoleCannotBeChanged':
    'Die Benutzerrolle kann für eine bestehende Position nicht geändert werden. Erstellen Sie stattdessen eine neue Position für ((userRole)).',
  'order.positions.autoId': 'Interne ID',
  'order.positions.autoId.explanation':
    'Diese ID wird automatisch generiert, basierend auf dem Einsatzbereich und der englischen Positionsbezeichnung. Sie kann nicht manuell geändert werden.',
  'order.paymentInterval': 'Verrechnungsintervall',
  'order.billingType': 'Zahlungsmodalität',
  'order.noCustomerSelected': 'Kein Kunde ausgewählt',
  'order.searchForCustomer': 'Nach Kunden suchen...',
  'order.searchForAnotherCustomer': 'Nach anderem Kunden suchen...',
  'order.new.success': 'Bestellung erfolgreich erstellt.',
  'order.new.error': 'Bestellung konnte nicht erstellt werden.',
  'order.approve': 'Freigeben',
  'order.approve.date': 'Freigabedatum',
  'general.createdBy': 'Erstellt von',
  'order.customer': 'Kunde',
  'order.date': 'Erstellt am',
  'order.decline': 'Ablehnen',
  'order.internalOrder': 'Interner Auftrag',
  'order.order': 'Auftrag',
  'order.sender': 'Sender',
  'order.sender.info.canSelect':
    'Der Sender wird automatisch ausgewählt, auf Basis von (1) dem gewählten Kunden (und dessen Land) und (2) der gewählten Positionen. Mit Ihren aktuellen Benutzerrechten können Sie den Sender allerdings manuell ändern.',
  'order.sender.info.canNotSelect':
    'Der Sender wird automatisch ausgewählt, auf Basis von (1) dem gewählten Kunden (und dessen Land) und (2) der gewählten Positionen.',
  'order.sender.wasChanged': "Der Sender wurde automatisch zu '((newSender))' geändert.",
  'order.sender.placeholder.canSelect': 'Bitte Sender auswählen...',
  'order.sender.placeholder.canNotSelect': 'Sender wird automatisch gewählt...',
  'order.position.amount': 'Menge',
  'order.position.minAmount': 'Mindestmenge',
  'order.position.maxAmount': 'Höchstmenge',
  'order.position.set': 'Festlegen',
  'order.position.unset': 'Nicht festlegen',
  'order.position.maxAmount.error.lowerThanMin': 'Höchstmenge ist kleiner als Mindestmenge',
  'order.position.minAmount.error.isZero':
    "Wenn die Mindestmenge 0 sein soll, diese bitte stattdessen 'Nicht festlegen'",
  'order.position.maxAmount.error.isZero': 'Eine Höchstmenge von 0 ist nicht gültig',
  'order.position.limitNotSet': 'keine',
  'order.position.amount.belowMin': 'Mindestmenge für diese Position ist ((minAmount))',
  'order.position.amount.aboveMax': 'Maximalmenge für diese Position ist ((maxAmount))',
  'order.position.amount.aboveStandardMax':
    'Maximalmenge pro Position für STANDARD-Vorbestellungen ist ((standardLimitPerPosition))',
  'order.position.pos': 'POS',
  'order.preOrder': 'Vorbestellung',
  'order.priority.HIGH': 'Sehr dringend',
  'order.priority.LOW': 'Nicht dringend',
  'order.priority.MID': 'Dringend',
  'order.status': 'Status',
  'order.status.ALL_OPEN_ORDERS': 'Alle offenen Bestellungen',
  'order.status.ALL_OPEN_PREORDERS': 'Alle offenen Vorbestellungen',
  'order.status.ALL_ORDERS': 'Alle Bestellungen',
  'order.status.ALL_PREORDERS': 'Alle Vorbestellungen',
  'order.status.BEING_PREPARED': 'In Vorbereitung',
  'order.status.DELIVERED': 'Zugestellt',
  'order.status.FLAWED': 'Fehlerhaft',
  'order.status.INTERNAL_ORDER_COMPLETED': 'Abgeschlossen',
  'order.status.NEW': 'Neu',
  'order.status.DECLINED': 'Abgelehnt',
  'order.status.PREORDER': 'Vorbestellung',
  'order.status.PREORDER_COMPLETED': 'Abgeschlossen',
  'order.status.SHIPPED': 'Versandt',
  'order.updatedAt': 'Zuletzt bearbeitet am',
  'general.updatedBy': 'Zuletzt bearbeitet von',
  'general.forWhom': 'Für ((who))',
  'general.date.inThePast': 'Datum liegt in der Vergangenheit',
  'general.date.inTheFuture': 'Datum liegt in der Zukunft',
  'page.ADD_NEW_ORDER': 'Neue Bestellung',
  'page.ADD_NEW_PREORDER': 'Neue Vorbestellung',
  'page.CONTACT_LIST': 'Kontakt-Liste',
  'page.EDIT_NEW_ORDER': 'Neue Bestellung bearbeiten',
  'page.EDIT_ORDER': 'Bestellung bearbeiten',
  'page.POSITIONS': 'Positionen',
  'page.ADD_NEW_POSITION': 'Neue Position anlegen',
  'page.EDIT_POSITION': 'Position bearbeiten',
  'page.COPY_POSITION': 'Position kopieren',
  'payment.allocation': 'Zuweisung',
  'payment.date': 'Datum',
  'payment.deliveryLocation': 'Übergabeort',
  'payment.open': 'Offen',
  'payment.paid': 'Bezahlt',
  'payment.payments': 'Zahlungen',
  'payment.submit': 'Erstellen',
  'payment.surplus': 'Überschuss',
  'payment.total': 'Summe',
  'payment.creation.success': 'Zahlung erfolgreich erfasst',
  'payment.creation.error': 'Zahlung konnte nicht erfasst werden',
  'paymentInterval.HALF_YEARLY': 'Halbjährlich',
  'paymentInterval.MONTHLY': 'Monatlich',
  'paymentInterval.QUARTERLY': 'Quartalsweise',
  'paymentInterval.YEARLY': 'Jährlich',
  'paymentInterval.paymentInterval': 'Zahlungsinterval',
  'paymentInterval.xMonths.x': 'Jeden Monat',
  'paymentInterval.xMonths.1': 'Ein Monat',
  'paymentInterval.xMonths.2': 'Auf zwei Monate aufteilen',
  'paymentInterval.xMonths.3': 'Auf drei Monate aufteilen',
  'paymentInterval.xMonths.4': 'Auf vier Monate aufteilen',
  'paymentInterval.xMonths.5': 'Auf fünf Monate aufteilen',
  'paymentInterval.xMonths.6': 'Auf sechs Monate aufteilen',
  'paymentInterval.xMonths.7': 'Auf sieben Monate aufteilen',
  'paymentInterval.xMonths.8': 'Auf acht Monate aufteilen',
  'paymentInterval.xMonths.9': 'Auf neun Monate aufteilen',
  'paymentInterval.xMonths.10': 'Auf zehn Monate aufteilen',
  'paymentInterval.xMonths.11': 'Auf elf Monate aufteilen',
  'paymentInterval.xMonths.12': 'Auf zwölf Monate aufteilen',
  'preorder.noFurtherPreordersAvailable': 'Keine weiteren Vorbestellungen verfügbar',
  'preorder.new.success': 'Vorbestellung erfolgreich erstellt',
  'preorder.new.error': 'Erstellung der Vorbestellung fehlgeschlagen',
  'preorder.deliveryConditions': 'Lieferbedingungen',
  'preorder.deliveryConditions.text': '7 Tage ab Bestätigung.',
  'preorder.express': 'Express',
  'preorder.limitReached': 'Express-Limit pro Monat erreicht',
  'preorder.maxAmount': 'Gesamtmenge',
  'preorder.maxAmountExpress': 'Gesamtmenge (max. ((maxAmount)) Stück)',
  'preorder.notes': 'Anmerkungen',
  'preorder.paymentConditions': 'Zahlungsbedingungen',
  'preorder.paymentConditions.text':
    'Die bestellte Ware ist ab Fertigstellung der Bestellung des jeweiligen Monats zu bezahlen.',
  'preorder.standard': 'Standard',
  'preorder.storageLocation': 'Lagerort',
  'preorder.type': 'Typ',
  'section.ADD_NEW_INTERNAL_ORDER': 'Interne Bestellung hinzufügen',
  'section.ADD_NEW_ORDER': 'Bestellung hinzufügen',
  'section.ADD_NEW_PAYMENT': 'Zahlung hinzufügen',
  'section.ADD_NEW_PREORDER': 'Vorbestellung hinzufügen',
  'section.ARCHIVE': 'Archiv',
  'section.CONTACT_LIST': 'Kontakte',
  'section.GUIDELINE': 'Richtlinien',
  'section.NEW_ORDERS': 'Neue Bestellungen',
  'section.DECLINED_ORDERS': 'Abgelehnte Bestellungen',
  'section.ORDER_OVERVIEW': 'Bestellübersicht online',
  'section.PAYMENTS': 'Zahlungen',
  'section.PREORDER_OVERVIEW': 'Bestellübersicht Vorbestellung',
  'section.ACCOUNT': 'Benutzerkonto',
  'section.OPTIONS': 'Optionen',
  'section.POSITIONS': 'Positionen',
  'options.section.PRICES': 'Preise',
  'validation.alreadyExists': 'Bereits vergeben',
  'validation.cannotBeEmpty': 'Darf nicht leer sein',
  'validation.invalidDate': 'Ungültiges Datum',
  'validation.invalidMail': 'Ungültige Mailadresse',
  'validation.invalidZipcode': 'Ungültige PLZ',
  'validation.tooLong': 'Zu lang',
  'validation.tooShort': 'Zu kurz',
  'validation.firstNameTooLong': 'Vorname zu lang',
  'validation.lastNameTooLong': 'Nachname zu lang',
  'validation.firstNameTooShort': 'Vorname zu kurz',
  'validation.lastNameTooShort': 'Nachname zu kurz',
  'validation.noCompanyButAlsoNoPerson': 'Firmenname oder Personenname erforderlich',
  'validation.noFirstName': 'Vorname erforderlich',
  'validation.noLastName': 'Nachname erforderlich',
  'general.close': 'Schließen',
  'general.createdAt': 'Erstellt am',
  'general.updatedAt': 'Zuletzt bearbeitet am',
  'general.sorting': 'Sortierung',
  'order.priority': 'Priorität',
  'order.decide.approved.success': 'Bestellung erfolgreich freigegeben',
  'order.decide.declined.success': 'Bestellung erfolgreich abgelehnt',
  'order.decide.approved.error': 'Fehler aufgetreten beim Versuch die Bestellung freizugeben',
  'order.decide.declined.error': 'Fehler aufgetreten beim Versuch die Bestellung abzulehnen',
  'general.ok': 'Ok',
  'general.cancel': 'Abbrechen',
  'general.cannotBeNegative': 'Darf nicht negativ sein',
  'general.cannotBeUndefined': 'Muss vorhanden sein',
  'general.cannotBeLowerThanX': 'Muss mindestens ((minAmount)) sein',
  'general.mustBeInteger': 'Muss eine Ganzzahl sein',
  'price.currentPrice': 'Aktueller Preis',
  'price.newPrice': 'Neuer Preis',
  'price.submit.success': 'Preis erfolgreich aktualisiert',
  'price.submit.error': 'Preis-Aktualisierung fehlgeschlagen',
  'price.changePrice': 'Preis ändern',
  'price.changePriceFirst': 'Noch kein Preis festgelegt... jetzt festlegen!',
  'price.hideHistory': 'Historie ausblenden',
  'price.showHistory': 'Historie einblenden',
  'price.setPrefix': 'Festgelegt vor ',
  'price.setSuffix': ', von ((createdBy))',
  'price.PALLETS': 'Paletten-Preise',
  'price.UK': 'UK-Preise',
  'price.GENERIC.change': '((unit))-Preis ändern',
  'price.GENERIC.changeFirst': '((unit))-Preis erstmalig festlegen',
  'general.pleaseWait': 'Bitte warten...',
  'general.errorOccurred': 'Ein Fehler ist aufgetreten',
  'general.createdByAt': 'Erstellt von <strong>((createdBy))</strong>, am <strong>((createdAt))</strong>',
  'general.updatedByAt': 'Zuletzt bearbeitet von <strong>((updatedBy))</strong>, am <strong>((updatedAt))</strong>',
  'general.showAll': 'Alle anzeigen',
  'order.new.xHiddenOrders': {
    singular: '((x)) weitere neue Bestellung ausgeblendet',
    plural: '((x)) weitere neue Bestellungen ausgeblendet',
  },
  'order.declined.xHiddenOrders': {
    singular: '((x)) weitere abgelehnte Bestellung ausgeblendet',
    plural: '((x)) weitere abgelehnte Bestellungen ausgeblendet',
  },
  'order.goToFocusedView': 'Gehe zu fokussierter Ansicht',
  'order.new.empty': 'Keine neuen Bestellungen vorhanden',
  'order.declined.empty': 'Keine abgelehnten Bestellungen vorhanden',
  'pagination.noResults': 'Keine Ergebnisse',
  'pagination.warningFiltersAreActive': 'Achtung: Filter sind aktiv!',
  'order.decide.approve.confirm': 'Bestellung <span style="font-weight: bold;">((orderId))</span> wirklich freigeben?',
  'order.decide.decline.confirm': 'Bestellung <span style="font-weight: bold;">((orderId))</span> wirklich ablehnen?',
  'general.mandatory': 'verpflichtend',
  'general.logout': 'Ausloggen',
  'position.submit.NEW': 'Neue Position anlegen',
  'position.submit.COPY': 'Neue Position (Kopie) anlegen',
  'position.submit.EDIT': 'Änderungen speichern',
  'position.submit.NEW.success': 'Neue Position erfolgreich angelegt',
  'position.submit.COPY.success': 'Neue Position (Kopie) erfolgreich angelegt',
  'position.submit.EDIT.success': 'Position erfolgreich bearbeitet',
  'position.submit.NEW.error': 'Anlegen der neuen Position fehlgeschlagen',
  'position.submit.COPY.error': 'Anlegen der neuen Position (Kopie) fehlgeschlagen',
  'position.submit.EDIT.error': 'Speichern der Positions-Änderungen fehlgeschlagen',
  'position.disable.warning.title': 'Position ((positionId)) deaktivieren?',
  'position.disable.warning.description':
    'Sie sind dabei Position ((positionId)) zu deaktivieren. Das bedeutet, dass diese für jegliche Benutzer für zukünftige Bestellungen nicht mehr zur Verfügung stehen wird.\n\nSind Sie sicher?',
  'position.disable.submit.success': 'Position erfolgreich deaktiviert',
  'position.disable.submit.error': 'Deaktivierung von Position fehlgeschlagen',
  'archive.download.success': 'Datei-Download erfolgreich',
  'archive.download.error': 'Datei-Download fehlgeschlagen',
  'payments.complete': 'Abgeschlossene Monate (((count))):',
  'payments.incomplete': 'Offene Monate (((count))):',
};
